import { Button } from '@cian/ui-kit';
import { IconFileTrash16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ModalConfirmRemoveAllContainer } from './ModalConfirmRemoveAllContainer';
import { ModalConfirmRemoveContainer } from './ModalConfirmRemoveContainer';
import { ModalConfirmRemoveFromFolderContainer } from './ModalConfirmRemoveFromFolderContainer';
import { trackRemoveAllClick, trackRemoveClick } from './tracking';
import { selectSelectedFolder } from '../../../selectors/folders';
import { selectSelectedProducts } from '../../../selectors/selected';
import { removeByIds } from '../../../thunk/favorites';
import { isHideModalConfirmRemoveFromFavorites } from '../../../utils/remove';

export function RemoveContainer() {
  const dispatch = useDispatch();
  const [isConfirmModalVisible, setConfirmModalVisible] = React.useState(false);
  const selectedProducts = useSelector(selectSelectedProducts);
  const selectedFolder = useSelector(selectSelectedFolder);
  const selectedCount = selectedProducts.length;

  const handleClick = () => {
    if (selectedCount) {
      trackRemoveClick(selectedProducts);
      if (!selectedFolder && isHideModalConfirmRemoveFromFavorites()) {
        dispatch(removeByIds());

        return;
      }
    } else {
      trackRemoveAllClick();
    }
    setConfirmModalVisible(true);
  };

  const handleClose = () => {
    setConfirmModalVisible(false);
  };

  let modal;
  if (selectedFolder) {
    modal = <ModalConfirmRemoveFromFolderContainer onClose={handleClose} />;
  } else {
    modal = selectedCount ? (
      <ModalConfirmRemoveContainer onClose={handleClose} />
    ) : (
      <ModalConfirmRemoveAllContainer onClose={handleClose} />
    );
  }

  return (
    <>
      {isConfirmModalVisible && modal}
      <Button
        beforeIcon={<IconFileTrash16 color="icon-main-default" />}
        size="XS"
        theme="fill_white_primary"
        onClick={handleClick}
      >
        {selectedCount ? 'Удалить' : 'Удалить все'}
      </Button>
    </>
  );
}
